import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import {
  setActiveCatalogueCount,
  setBuyersCount,
  setCatalogueCount,
  setFairEnquiriesCount,
  setProductCount,
  setQuotationCount,
  setShouldFetchProducts
} from './dashboardSlice';
import globalIP from '../GlobelIP';

const ProductAPIFetcher = () => {
  const ipp = globalIP;
  const dispatch = useDispatch();
  const shouldFetch = useSelector(state => state.dashboard.shouldFetchProducts);

  useEffect(() => {
    if (!shouldFetch) return;

    async function loadProducts() {
      const productResponse = await fetch(
        `${ipp}/api/products?populate=*&sort[0]=${'id:desc'}&pagination[page]=1&pagination[pageSize]=1`
      );

      const catalogueResponse = await fetch(
        `${ipp}/api/catalogues?populate=*&sort[0]=id:desc&pagination[page]=1&pagination[pageSize]=1`
      );
      const activeCatalogueResponse = await fetch(
        `${ipp}/api/catalogues?populate=*&sort[0]=id:desc&pagination[page]=1&pagination[pageSize]=1&filters[Status][$eq]=Active`
      );
      const quotationResponse = await fetch(
        `${ipp}/api/quotations?populate=*&sort[0]=id:desc&pagination[page]=1&pagination[pageSize]=1`
      );
      const buyersResponse = await fetch(
        `${ipp}/api/buyer-details?populate=*&sort[0]=id:desc&pagination[page]=1&pagination[pageSize]=1`
      );
      const enquiryResponse = await fetch(
        `${ipp}/api/buyqr-enquiries?populate=*&sort[0]=id:desc&pagination[page]=1&pagination[pageSize]=1`
      );

      const productJson = await productResponse.json();
      const allCataJson = await catalogueResponse.json();
      const allActiveCataJson = await activeCatalogueResponse.json();
      const quotationJson = await quotationResponse.json();
      const buyersJson = await buyersResponse.json();
      const enquiryJson = await enquiryResponse.json();

      dispatch(setProductCount(productJson.meta.pagination.total));
      dispatch(setCatalogueCount(allCataJson.meta.pagination.total));
      dispatch(setActiveCatalogueCount(allActiveCataJson.meta.pagination.total));
      dispatch(setQuotationCount(quotationJson.meta.pagination.total));
      dispatch(setBuyersCount(buyersJson.meta.pagination.total));
      dispatch(setFairEnquiriesCount(enquiryJson.meta.pagination.total));

      dispatch(setShouldFetchProducts(false)); // reset after fetch
    }

    loadProducts();
  }, [shouldFetch]);

  return null; // invisible background component
};

export default ProductAPIFetcher;
